import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { pageProps } from 'lib/analytics/page-properties';
import { BUTTON_IMPRESSION, BUTTON_CLICK } from 'lib/analytics/events';
import { Location } from 'models/locations';

const propTypes = {
  app: PropTypes.string,
  trackEvent: PropTypes.func,
  location: PropTypes.instanceOf(Location).isRequired,
  analyticsPosition: PropTypes.number,
};

const defaultProps = {
  app: '',
  trackEvent: () => {},
  analyticsPosition: 0,
};

class LocationImageHeader extends Component {
  constructor(props) {
    super(props);

    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onVisibilityChange(isVisible) {
    const { trackEvent, app, analyticsPosition } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({ app });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'Directions',
        position: analyticsPosition.toString(),
      });
    }
  }

  onClick() {
    const { trackEvent, app, analyticsPosition } = this.props;
    const pageProperties = pageProps({ app });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'Directions',
      position: analyticsPosition.toString(),
    });
  }

  render() {
    const { location } = this.props;
    return (
      <div>
        <div>{location.address}</div>
        <div className="weak">{location.name}</div>
        <div className="deco-directions-right">
          <VisibilitySensor onChange={this.onVisibilityChange} partialVisibility>
            <a href={location.googleMapURL()} target="_blank" onClick={this.onClick}>Get Directions</a>
          </VisibilitySensor>
        </div>
      </div>
    );
  }
}

LocationImageHeader.propTypes = propTypes;
LocationImageHeader.defaultProps = defaultProps;
export default LocationImageHeader;
